import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { PermissionEnum } from 'src/app/core/permissions/permission.enum';
import { AuthService } from 'src/app/features/authentication/services/auth.service';
import { SearchService } from 'src/app/features/search/search.service';
import { SearchBaseComponent } from '../../../search/components/search-base/search-base.component';
import { getIdsFromItemFormControl } from '../../../search/search.utils';
import { SearchFilterService } from '../../../search/services/search-filter.service';
import { PartnerSearchModel } from '../../models/partner-search.model';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { SearchFilterContainerComponent } from '../../../search/components/search-filter-container/search-filter-container.component';
import {
  SearchFilterColumnsComponent,
  SearchFilterColumnDirective
} from '../../../search/components/search-filter-columns/search-filter-columns.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { PermittedDirective } from '@core/permissions/permitted.directive';
import { OrgTreeFilterComponent } from '../../../search/components/filters/org-tree-filter/org-tree-filter.component';
import { GeographyFilterComponent } from '../../../search/components/filters/geography-filter/geography-filter.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-partner-search',
  templateUrl: './partner-search.component.html',
  imports: [
    SearchFilterContainerComponent,
    ReactiveFormsModule,
    SearchFilterColumnsComponent,
    SearchFilterColumnDirective,
    MatCheckbox,
    PermittedDirective,
    OrgTreeFilterComponent,
    GeographyFilterComponent,
    TranslateModule
  ]
})
export class PartnerSearchComponent extends SearchBaseComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private searchService = inject(SearchService);
  private cd = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private wsHelperService = inject(WsHelperService);

  constructor() {
    const searchFilterService = inject(SearchFilterService);

    super(searchFilterService);
  }

  ngOnInit() {
    this.initializePartnerSearchForm();
    this.loadFilters();
  }

  protected getSearchFilters(): PartnerSearchModel {
    return Object.assign({}, this.searchFormGroup.value, this.getOrgTreeRequestParams(), this.getGeoographyTreeRequestParams());
  }

  loadFilters(): void {
    if (this.authService.checkUserPermission(PermissionEnum.GET_ORG_TREE_FILTERS)) {
      this.wsHelperService.callWithSpinner(this.searchService.getOrgTreeFilters()).subscribe(filters => {
        this.orgTreeFiltersData = filters;
        this.cd.detectChanges();
      });
    }
  }

  private getOrgTreeRequestParams(): Record<string, string[]> {
    const keysToMap = ['partners', 'treatmentCenters'];

    return getIdsFromItemFormControl(this.searchFormGroup, keysToMap);
  }

  private getGeoographyTreeRequestParams(): Record<string, string[]> {
    const keysToMap = ['crms', 'crmRegions', 'countries', 'zoneCountries', 'provinces', 'zoneProvinces'];

    return getIdsFromItemFormControl(this.searchFormGroup, keysToMap);
  }

  private initializePartnerSearchForm(): void {
    this.searchFormGroup = this.formBuilder.group({
      active: [false],
      inactive: [false],
      outreachCenter: [false],
      webIgnore: [false],
      allowSurgery: [false],
      allowAbg: [false],
      allowVelo: [false],
      allowOrthognathic: [false],
      allowOrtho: [false],
      allowSpeech: [false],
      allowNutrition: [false],
      allowDental: [false],
      allowEnt: [false],
      allowPsychosocial: [false],
      costSharePrimaryNotCovered: [false],
      partners: [[]],
      treatmentCenters: [[]],
      crms: [[]],
      crmRegions: [[]],
      countries: [[]],
      zoneCountries: [[]],
      provinces: [[]],
      zoneProvinces: [[]]
    });
  }
}
